export const PWA_INSTALL_ROUTE = '/install-app';
export const PWA_INSTALL_MAIN_ROUTES = Object.freeze(['/client', '/guest']);
export const PWA_INSTALL_PROMOTION_DELAY_MS = 1200;
export const PWA_INSTALL_SNOOZE_MS = 7 * 24 * 60 * 60 * 1000;
export const PWA_INSTALL_GUIDE_COOLDOWN_MS = 24 * 60 * 60 * 1000;
export const PWA_INSTALL_STORAGE_PREFIX = 'gnegnegne_pwa_install_v1';
export const PWA_INSTALLED_DISPLAY_MODES = Object.freeze(['standalone', 'minimal-ui', 'fullscreen']);
